import { useMediaSettings } from "@circle-react-uikit/MediaSettings/useMediaSettings";

interface UseMediaConfigProps {
  isDownloadable?: boolean;
  mediaTranscriptId?: number;
  posterUrl?: string;
  signedId: string;
}

interface UseMediaConfigReturn {
  isDownloadable?: boolean;
  mediaTranscriptId?: number;
  posterUrl?: string;
}

export const useMediaConfig = ({
  isDownloadable,
  mediaTranscriptId,
  posterUrl,
  signedId,
}: UseMediaConfigProps): UseMediaConfigReturn => {
  const { mediaSettings } = useMediaSettings(signedId, false);

  return {
    mediaTranscriptId: mediaSettings
      ? (mediaSettings.transcript?.id ?? mediaTranscriptId)
      : mediaTranscriptId,
    isDownloadable: mediaSettings
      ? mediaSettings.make_downloadable
      : isDownloadable,
    posterUrl: mediaSettings
      ? (mediaSettings.custom_thumbnail_url ??
        mediaSettings.default_thumbnail_url)
      : posterUrl,
  };
};
